<template>
  <div class="license">
    <div class="zzhao" v-for="(item,i) in img" :key="i" v-if="$route.query.id - 0 === i">
      <img class="banner_img"
        :src="item.img"
        alt=""
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "license",
  data() {
    return {
      img: [
        {
          id:0,
          img: require("../../static/img/xkz.jpg")
        },
        {
          id:1,
          img: require("../../static/img/yyzz.png")
        }
      ]
    };
  }
};
</script>

<style  lang="scss" scoped>
.license {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  
.zzhao {
  height: 52vw;
  max-height: 1000px;
  max-width: 1920px;
  margin: 0 auto;
  background-color: #000;
}
.banner_img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
  height:100%;
}
}
</style>



// WEBPACK FOOTER //
// src/pages/License.vue